<template>
  <Tasps v-if="!userRole.includes('聚合') && !userRole.includes('单站演示') && !immersiveFullscreen" @remove="handleTabRemove" />

  <div class="content" :style="contentStyle">
    <div class="appdev scrollbar">
      <router-view v-slot="{ Component }">
        <keep-alive :include="keepAliveNames">
          <component :is="Component" :key="router.currentRoute.value.name" />
        </keep-alive>
      </router-view>
    </div>
  </div>

  <!-- 展示操作日志（拓扑图、空调系统图） -->
  <OperationLogDialogBox v-if="['WiringDiagram', 'AirCondition'].includes(router.currentRoute.value.name)" />
</template>

<script setup>
import Tasps from '@/components/layout/tasps.vue'
import { ref, watch, computed } from 'vue'
import router from '@/router'
import { useStore } from 'vuex'
import OperationLogDialogBox from '../components/operationLog/OperationLogDialogBox.vue'

const store = useStore()
const padding0Routes = ['ChargingSystem', 'PhotovoltaicSystem', 'EnergyStorageSystem', 'PowerDistribution', 'FanSystem', 'OtherLoadsSystem']

const userRole = computed(() => store.getters.getUserRole)
const immersiveFullscreen = computed(() => store.getters.getImmersiveFullscreen)
const contentStyle = computed(() => {
  if (immersiveFullscreen.value) {
    return 'padding: 0;border-left: none;height: 100vh'
  }
  return padding0Routes.includes(router.currentRoute.value.name) ? 'padding: 0;height:calc(100vh - 105px)' : ''
})
watch(
  () => router.currentRoute.value,
  val => {
    if (val.meta.keepAlive && store.getters.getkeepLive.indexOf(val.name) === -1) {
      store.dispatch('setkeepLive', val.name)
    }
  },
  { immediate: true, deep: true },
)

const keepAliveNames = computed(() => store.getters.getkeepLive)
const handleTabRemove = name => {
  setTimeout(() => {
    store.dispatch('delKeepLive', name)
  })
}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100vh - 125px);
  color: var(--el-color-white);
  border-left: 1px solid var(--line-color);
  padding: 10px 20px;
  padding-left: 0;

  .appdev {
    height: 100%;
    overflow: auto;
  }
}
</style>
